const drinkRows = [
  { time: '21:00〜', duration: '60分', price: '3,000円' },
  { time: '22:00〜', duration: '60分', price: '4,000円' },
];

const bottleRows = [
  { label: '平日', duration: '90分', price: '4,000円' },
  { label: '週末', duration: '60分', price: '3,000円' },
  { label: '割もの', duration: '—', price: '別途あり' },
];

const optionRows = [
  { label: '延長 60分', value: '3,000円' },
  { label: '指名料', value: '1,000円' },
  { label: '延長 30分', value: '2,000円' },
  { label: 'カラオケ', value: '1,000円 / 組' },
  { label: 'TAX', value: '10%' },
  { label: 'サービス料', value: '10%' },
  { label: 'カード手数料', value: '無料' },
  { label: '電子決済手数料', value: '無料' },
];

interface TableBlockProps {
  title: string;
  sub: string;
  note?: string;
  headers: string[];
  rows: string[][];
}

function TableBlock({ title, sub, note, headers, rows }: TableBlockProps) {
  return (
    <div>
      {/* Block title */}
      <div className="flex items-baseline gap-3 mb-4">
        <h3
          className="text-sm font-medium tracking-[0.2em]"
          style={{ fontFamily: "'Noto Serif JP', serif", color: '#2a2a2a' }}
        >
          {title}
        </h3>
        <span className="text-xs tracking-wider" style={{ color: '#AAC4DC' }}>{sub}</span>
        {note && <span className="text-xs text-gray-400 tracking-wide ml-auto">{note}</span>}
      </div>

      {/* Table */}
      <div className="w-full overflow-hidden rounded-lg" style={{ border: '1px solid rgba(170,196,220,0.3)' }}>
        {/* Header row */}
        <div
          className="grid text-xs tracking-widest"
          style={{
            gridTemplateColumns: `repeat(${headers.length}, 1fr)`,
            background: 'rgba(170,196,220,0.15)',
            borderBottom: '1px solid rgba(170,196,220,0.3)',
          }}
        >
          {headers.map((h) => (
            <div key={h} className="px-5 py-2.5 text-center" style={{ color: '#AAC4DC', fontFamily: "'Noto Serif JP', serif" }}>
              {h}
            </div>
          ))}
        </div>
        {/* Data rows */}
        {rows.map((row, i) => (
          <div
            key={i}
            className="grid text-sm"
            style={{
              gridTemplateColumns: `repeat(${headers.length}, 1fr)`,
              borderBottom: i < rows.length - 1 ? '1px solid rgba(170,196,220,0.2)' : 'none',
              background: i % 2 === 0 ? '#fff' : 'rgba(170,196,220,0.04)',
            }}
          >
            {row.map((cell, j) => (
              <div
                key={j}
                className="px-5 py-3.5 text-center tracking-wide"
                style={{
                  color: j === row.length - 1 ? '#2a2a2a' : '#555',
                  fontFamily: j === row.length - 1 ? "'Noto Serif JP', serif" : 'inherit',
                  fontWeight: j === row.length - 1 ? 500 : 400,
                  borderRight: j < row.length - 1 ? '1px solid rgba(170,196,220,0.2)' : 'none',
                }}
              >
                {cell}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function SystemSection() {
  return (
    <section id="system" className="w-full py-20 md:py-28" style={{ background: '#f8f9fb' }}>
      <div className="max-w-4xl mx-auto px-6">

        {/* Section heading */}
        <div className="text-center mb-14">
          <p
            className="text-xs tracking-[0.35em] mb-3"
            style={{ color: '#AAC4DC', fontFamily: "'Noto Serif JP', serif" }}
          >
            SYSTEM
          </p>
          <h2
            className="text-2xl md:text-3xl font-medium tracking-[0.2em]"
            style={{ fontFamily: "'Noto Serif JP', serif", color: '#2a2a2a' }}
          >
            システム
          </h2>
          <div className="flex items-center justify-center gap-3 mt-5">
            <div className="h-px w-16" style={{ background: '#AAC4DC' }} />
            <div className="w-1.5 h-1.5 rounded-full" style={{ background: '#AAC4DC' }} />
            <div className="h-px w-16" style={{ background: '#AAC4DC' }} />
          </div>
        </div>

        {/* Tables */}
        <div className="flex flex-col gap-10">

          {/* Drink */}
          <TableBlock
            title="飲み放題"
            sub="ALL YOU CAN DRINK"
            note="焼酎・ウイスキー"
            headers={['時間帯', '時間', '料金']}
            rows={drinkRows.map((d) => [d.time, d.duration, d.price])}
          />

          {/* Divider */}
          <div className="h-px w-full" style={{ background: 'rgba(170,196,220,0.25)' }} />

          {/* Bottle */}
          <TableBlock
            title="ボトルセット"
            sub="BOTTLE SET"
            note="割もの別途あり"
            headers={['種別', '時間', '料金']}
            rows={bottleRows.map((b) => [b.label, b.duration, b.price])}
          />

          {/* Divider */}
          <div className="h-px w-full" style={{ background: 'rgba(170,196,220,0.25)' }} />

          {/* Options */}
          <div>
            <div className="flex items-baseline gap-3 mb-4">
              <h3
                className="text-sm font-medium tracking-[0.2em]"
                style={{ fontFamily: "'Noto Serif JP', serif", color: '#2a2a2a' }}
              >
                オプション・その他
              </h3>
              <span className="text-xs tracking-wider" style={{ color: '#AAC4DC' }}>OPTIONS</span>
            </div>
            <div
              className="w-full overflow-hidden rounded-lg"
              style={{ border: '1px solid rgba(170,196,220,0.3)' }}
            >
              {/* Header */}
              <div
                className="grid grid-cols-2 text-xs tracking-widest"
                style={{
                  background: 'rgba(170,196,220,0.15)',
                  borderBottom: '1px solid rgba(170,196,220,0.3)',
                }}
              >
                <div className="px-5 py-2.5 text-center" style={{ color: '#AAC4DC', fontFamily: "'Noto Serif JP', serif", borderRight: '1px solid rgba(170,196,220,0.2)' }}>
                  項目
                </div>
                <div className="px-5 py-2.5 text-center" style={{ color: '#AAC4DC', fontFamily: "'Noto Serif JP', serif" }}>
                  料金
                </div>
              </div>
              {/* Rows — 2 columns layout */}
              <div className="grid grid-cols-1 sm:grid-cols-2">
                {optionRows.map((opt, i) => (
                  <div
                    key={opt.label}
                    className="flex items-center justify-between px-5 py-3.5 text-sm"
                    style={{
                      borderBottom: i < optionRows.length - (optionRows.length % 2 === 0 ? 2 : 1) ? '1px solid rgba(170,196,220,0.2)' : 'none',
                      borderRight: i % 2 === 0 ? '1px solid rgba(170,196,220,0.2)' : 'none',
                      background: Math.floor(i / 2) % 2 === 0 ? '#fff' : 'rgba(170,196,220,0.04)',
                    }}
                  >
                    <span className="tracking-wide" style={{ color: '#555' }}>{opt.label}</span>
                    <span
                      className="font-medium tracking-wide"
                      style={{ color: '#2a2a2a', fontFamily: "'Noto Serif JP', serif" }}
                    >
                      {opt.value}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>

        {/* Note */}
        <p className="text-center text-xs text-gray-400 tracking-wider mt-10">
          ※ 料金はすべて税別表示です。TAX・サービス料が別途かかります。<br />
          ※インボイス対応
        </p>
      </div>
    </section>
  );
}
